import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { PersonEngagement } from '@interfaces';


export function getColumns(util: UtilityService) {

	const columns: GridColumn<PersonEngagement, unknown>[] = [
		buildColumn(util, 'Id', row => row.engagementId, { header: 'engagementId' }),
		buildColumn(util, 'FullName', row => row.engagementLastContactStaffName, { header: 'Last Contacted By' }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.engagementLastContactUTC), { header: 'Last Contacted Date' }),
		buildColumn(util, 'Text', row => row.details, { header: 'Details' }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.followUpDateUTC), { header: 'Follow Up' }),
	];

	return columns;

}